import { render } from "./MediaTable.vue?vue&type=template&id=6e9f1412&scoped=true"
import script from "./MediaTable.vue?vue&type=script&lang=js"
export * from "./MediaTable.vue?vue&type=script&lang=js"

import "../css/components/MediaTable.css?vue&type=style&index=0&id=6e9f1412&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9f1412"]])

export default __exports__